import(/* webpackMode: "eager" */ "/home/jenkins/deployment/obituary-app/staging-fe/obituary-app-fe/app/primerjava/page.tsx");
